/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSuccessDto } from '../../models/lexplus-success-dto';
import { LexplusUpdateStandortBerichtDto } from '../../models/lexplus-update-standort-bericht-dto';

export interface StandortBerichtControllerUpdateFromUploadV1$Params {
      body: LexplusUpdateStandortBerichtDto
}

export function standortBerichtControllerUpdateFromUploadV1(http: HttpClient, rootUrl: string, params: StandortBerichtControllerUpdateFromUploadV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, standortBerichtControllerUpdateFromUploadV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

standortBerichtControllerUpdateFromUploadV1.PATH = '/v1/standort-bericht/update-from-upload';
